import React from "react";

const StatusToast = ({ message = "", type = "success", onClose }) => {
  if (!message) return null;

  return (
    <div className={`status-toast ${type === "error" ? "error" : "success"}`} role="status" aria-live="polite">
      <span>{message}</span>
      <button type="button" className="status-toast-close" onClick={onClose} aria-label="Close">
        ×
      </button>
    </div>
  );
};

export default StatusToast;
